import { ctxReport } from '@/contexts/ReportCtx';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { Checkbox, Divider, List, ListItem, ListItemIcon, ListItemText, MenuItem, Typography } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import CustomDrawer from '../CustomDrawer';
import CustomPopover from '../CustomPopover';

export default function MorePopup({
  anchorEl,
  handleClose,
}: {
  anchorEl: HTMLButtonElement | null;
  handleClose: () => void;
}) {
  const reportCtx = useContext(ctxReport);
  const { t } = useTranslation();

  if (!reportCtx) return;

  function handleClick() {
    reportCtx?.setShowDeactivated((prev) => !prev);
  }

  const menuList = () => [
    {
      key: 'driver-list-showDeactivated',
      content: (
        <>
          <ListItemIcon>
            <Checkbox color="secondary" size={'medium'} checked={reportCtx.showDeactivated} />
          </ListItemIcon>
          <ListItemText>{t('filter.showDeactivatedDrivers')}</ListItemText>
        </>
      ),
      onClick: handleClick,
    },
  ];

  return isPhoneOrHighScreen() ? (
    <CustomDrawer isOpen={Boolean(anchorEl)} onClose={handleClose}>
      <Typography variant="h5" sx={{ padding: '10px', marginLeft: '10px' }}>
        {t('general.settings')}
      </Typography>
      <Divider />
      <List>
        {menuList().map((listItem) => (
          <ListItem key={listItem.key} onClick={listItem.onClick}>
            {listItem.content}
          </ListItem>
        ))}
      </List>
    </CustomDrawer>
  ) : (
    <CustomPopover anchorEl={anchorEl} onClose={handleClose}>
      {menuList().map((listItem) => (
        <MenuItem key={listItem.key} onClick={listItem.onClick} sx={{ paddingLeft: '0px' }}>
          {listItem.content}
        </MenuItem>
      ))}
    </CustomPopover>
  );
}
